import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import {ScoreFactorGroup} from "models"
import ScoreFactorGroupsHalfCircleAverage from "components/score-factor-groups/half-circle-average"
import useModel from "@kaspernj/api-maker/build/use-model"

/**
 * @typedef {object} ComponentsScoreFactorGroupsMoodAverageProps
 * @property {unknown} defaultAverage
 * @property {unknown} scoreFactorGroup
 */

/** @typedef {object} ComponentsScoreFactorGroupsMoodAverageState */

/**
 * @extends {ShapeComponent<ComponentsScoreFactorGroupsMoodAverageProps, ComponentsScoreFactorGroupsMoodAverageState>}
 */
class ComponentsScoreFactorGroupsMoodAverage extends ShapeComponent {
  static propTypes = {
    defaultAverage: PropTypes.number,
    scoreFactorGroup: PropTypes.instanceOf(ScoreFactorGroup)
  }

  setup() {
    const {scoreFactorGroup} = useModel(ScoreFactorGroup, {
      query: ScoreFactorGroup.ransack({identifier_eq: "mood"}),
      select: {
        ScoreFactorGroup: ["id", "name"]
      }
    })

    this.scoreFactorGroup = this.props.scoreFactorGroup || scoreFactorGroup
  }

  render() {
    const {scoreFactorGroup} = this.tt
    const {defaultAverage, scoreFactorGroup: propsScoreFactorGroup, ...restProps} = this.props

    return (
      <>
        {scoreFactorGroup &&
          <ScoreFactorGroupsHalfCircleAverage
            addition={-1}
            defaultAverage={defaultAverage}
            max={4.0}
            scoreFactorGroup={scoreFactorGroup}
            {...restProps}
          />
        }
      </>
    )
  }
}

export default memo(shapeComponent(ComponentsScoreFactorGroupsMoodAverage))
